<form class="input-form" [formGroup]="searchForm">
  <app-input-field
    class="debounce-search-input"
    [theme]="theme"
    formControlName="searchString"
    [placeholder]="placeholder"
    [useErrorMessage]="false"
    (keyup)="onKeyup($event)"
    (keydown)="onKeydown($event)"
  ></app-input-field>
</form>

@if (isVisible) {
  <ul
    class="search-results scrollable-popover"
    (clickOutside)="clearResults()"
    >
    @if (listCategory && searchResults.length > 0) {
      <span
        class="list-category"
        >{{ listCategory }}</span
        >
      }
      @for (item of searchResults; track item) {
        <li
          class="flex search-result-item"
          (click)="handleItemClick(item)"
          >
          @if (displayConfig?.imageProperty) {
            <profile-image
              [image]="getProperty(item, displayConfig.imageProperty)"
      [fullName]="
        getProperty(item, displayConfig.primaryText) ||
        getProperty(item, displayConfig.defaultPrimaryText)
      "
              size="medium"
              class="result-image"
            ></profile-image>
          }
          @if (displayConfig) {
            <div
              [ngClass]="{ 'flex__column--start': !!displayConfig?.secondLineText }"
              >
              <div>
                {{
                getProperty(item, displayConfig.primaryText) ||
                getProperty(item, displayConfig.defaultPrimaryText)
                }}
                @if (displayConfig?.secondaryText) {
                  <span
                    class="result-secondary-text"
                    >
                    • {{ getProperty(item, displayConfig.secondaryText) }}
                  </span>
                }
              </div>
              @if (!!displayConfig?.secondLineText) {
                <div
                  class="result-secondary-text"
                  >
                  {{ getProperty(item, displayConfig.secondLineText) }}
                </div>
              }
            </div>
          }
          @if (!displayConfig) {
            <span> {{ formatResults(item) }} </span>
          }
        </li>
      }
      @if (
        searchResults.length === 0 &&
        searchForm.get('searchString').value.length > 2
        ) {
        <div
          class="no-results"
          >
          No results found.
        </div>
      }
    </ul>
  }
